import AScene from "../../library/ExtendedObjects/AScene.js";
import gameData from "../../gameData.js";
import ABCyaPhaser from "@abcya/abcya_phaser"
import FontKeys from "../../FontKeys.js";
import ABCyaLib from "@abcya/abcya_lib";
import LocalizationUIAssets from "../../Localization-UIAssets.js";
import { botRopePath, topRopePath } from "./RopePathPoints.js";

export default class Intro extends AScene
{
    static get KEY() { return 'Intro'; }
    
    create()
    {
      this.background = this.addImage(this.mid.x, this.mid.y, "Bckg");
      if(ABCyaLib.Environment.instance.locale === ABCyaLib.Environment.LOCALES.esUS){
        this.englishBtn = this.add.container(this.mid.x * 2 - 235, this.mid.y * 2 - 170).setDepth(100).setScale(0);
        this.englishBtnBG = this.addButton(0, 0, "Btn_English", null, () => { this.btnHandler("play"); }, this.englishBtn);
        const englishTxt = ABCyaPhaser.Text.addText(0, this.englishBtnBG.height/2 + 22, 32, 0xFFFFFF, FontKeys.din_alternatebold, gameData.maskLocalization.getLocalizedString("buttonNames.play", true), this.englishBtn, true).setResolution(1.5).setAngle(-3);
      } else {
        this.englishBtn = this.add.container(this.mid.x * 2 - 235, this.mid.y * 2 - 170).setDepth(100).setScale(0);
        this.englishBtnBG = this.addButton(0, 0, "Btn_English", null, () => { this.btnHandler("english"); }, this.englishBtn);
        const englishTxt = ABCyaPhaser.Text.addText(0, this.englishBtnBG.height/2 + 22, 32, 0xFFFFFF, FontKeys.din_alternatebold, gameData.maskLocalization.getLocalizedString("buttonNames.english", true), this.englishBtn, true).setResolution(1.5).setAngle(-3);

        this.spanishBtn = this.add.container(this.mid.x * 2 - 95, this.mid.y * 2 - 260).setDepth(100).setScale(0);
        this.spanishBtnBG = this.addButton(0, 0, "Btn_English", null, () => { this.btnHandler("spanish"); }, this.spanishBtn);
        const spanishTxt = ABCyaPhaser.Text.addText(2, this.spanishBtnBG.height/2 + 20, 28, 0xFFFFFF, FontKeys.din_alternatebold, ABCyaPhaser.Localization.instance.getLocalizedString("buttonNames.spanish", true), this.spanishBtn, true).setResolution(1.5).setAngle(-3);
      }

      this.toggleBtns(false);

      this.playJingle();
      
      this.createRopes();
      this.createMask();
      this.animateRopes();
      this.animateMask();
    }

    createRopes() {
      this.ropes = [];
      this.topRopes = [];
      this.botRopes = [];

      //Create obj data for each rope segment. Each segment has it's internal x,y,z and global index and a mask graphic.
      this.topRopesData = {
        ropeRefs: 
        [
          {x:496, y:110, z:0, ind:0, graphics: this.add.graphics({ fillStyle: { color: 0xff0000, alpha: 1 }, x: 0, y: 0 }).setVisible(false)},
          {x:449, y:138, z:0, ind:1, graphics: this.add.graphics({ fillStyle: { color: 0xff0000, alpha: 1 }, x: 0, y: 0 }).setVisible(false)},
          {x:222, y:207, z:0, ind:2, graphics: this.add.graphics({ fillStyle: { color: 0xff0000, alpha: 1 }, x: 0, y: 0 }).setVisible(false)}
        ],
        ropeCurve: new Phaser.Curves.Spline(topRopePath),
        c: new Phaser.GameObjects.Arc(this, topRopePath[0].x, topRopePath[0].y, 50, 0, 360, false, 0x00ff00, 1),
        path: new Phaser.Curves.Path(0, 0)
      }
      this.topRopesData.path.add(this.topRopesData.ropeCurve);

      this.botRopesData = {
        ropeRefs: 
        [
          {x:782, y:467, z:0, ind:0, graphics: this.add.graphics({ fillStyle: { color: 0xff0000, alpha: 1 }, x: 0, y: 0 }).setVisible(false)},
          {x:548, y:525, z:1, ind:1, graphics: this.add.graphics({ fillStyle: { color: 0xff0000, alpha: 1 }, x: 0, y: 0 }).setVisible(false)},
          {x:491, y:573, z:0, ind:0, graphics: this.add.graphics({ fillStyle: { color: 0xff0000, alpha: 1 }, x: 0, y: 0 }).setVisible(false)},
          {x:555, y:605, z:1, ind:1, graphics: this.add.graphics({ fillStyle: { color: 0xff0000, alpha: 1 }, x: 0, y: 0 }).setVisible(false)},
          {x:603, y:636, z:1, ind:0, graphics: this.add.graphics({ fillStyle: { color: 0xff0000, alpha: 1 }, x: 0, y: 0 }).setVisible(false)}
        ],
        ropeCurve: new Phaser.Curves.Spline(botRopePath),
        c: new Phaser.GameObjects.Arc(this, botRopePath[0].x, botRopePath[0].y, 50, 0, 360, false, 0x00ff00, 1),
        path: new Phaser.Curves.Path(0, 0)
      }
      this.botRopesData.path.add(this.botRopesData.ropeCurve);

      //create the top ropes
      for (let i = 0; i < this.topRopesData.ropeRefs.length; i++) {
        const rope = ABCyaPhaser.Images.addImage(this.topRopesData.ropeRefs[i].x, this.topRopesData.ropeRefs[i].y, 'String'+(i+1), this);
        rope.z = this.topRopesData.ropeRefs[i].z;
        rope.ind = this.topRopesData.ropeRefs[i].ind;

        if(!ABCyaLib.DEVICE_INFO.iOS){
          rope.graphics = this.topRopesData.ropeRefs[i].graphics;
          rope.setMask(rope.graphics.createGeometryMask());
        }
        
        this.topRopes.push(rope);
        this.ropes.push(rope);
      }

      //create the bottom ropes
      for (let i = 0; i < this.botRopesData.ropeRefs.length; i++) {
        const rope = ABCyaPhaser.Images.addImage(this.botRopesData.ropeRefs[i].x, this.botRopesData.ropeRefs[i].y, 'String'+(i+1+this.topRopesData.ropeRefs.length), this);
        rope.z = this.botRopesData.ropeRefs[i].z;
        rope.ind = this.botRopesData.ropeRefs[i].ind;

        if(!ABCyaLib.DEVICE_INFO.iOS){
          rope.graphics = this.botRopesData.ropeRefs[i].graphics;
          rope.setMask(rope.graphics.createGeometryMask());
        }
        
        this.botRopes.push(rope);
        this.ropes.push(rope);
      }
    }

    createMask()
    {
      //create the mask
      this.maskCont = this.add.container(this.mid.x, this.mid.y).setAlpha(0);
      const maskBG = ABCyaPhaser.Images.addImage(0, 0, 'introMaskTop', this.maskCont);
      const alpha = !ABCyaLib.DEVICE_INFO.iOS ? 0 : 1;
      this.maskTitleBG = ABCyaPhaser.Images.addImage(2, 0, LocalizationUIAssets._introTop, this.maskCont, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setAlpha(alpha);
      this.maskTitleBG.y = ABCyaLib.Environment.instance.gameConfig.intro.maskBGY;

      this.titleData = [];
      for (let i = 0; i < 5; i++) {
        let maskTitleRef = null;
        if(!ABCyaLib.DEVICE_INFO.iOS){
          maskTitleRef = ABCyaPhaser.Images.addImage(2, 0, LocalizationUIAssets._introTop, this.maskCont, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
          maskTitleRef.y = ABCyaLib.Environment.instance.gameConfig.intro.maskBGY;
        }

        const pointsArr = ABCyaLib.Environment.instance.gameConfig.intro.letterArr['letter_'+(i+1)];
        const ropeCurve = new Phaser.Curves.Spline(pointsArr);
        const c = new Phaser.GameObjects.Arc(this, pointsArr[0].x, pointsArr[0].y, 50, 0, 360, false, 0x00ff00, 1);
        const path = new Phaser.Curves.Path(0, 0).add(ropeCurve);
        const graphics = !ABCyaLib.DEVICE_INFO.iOS ? this.add.graphics({ fillStyle: { color: 0xff0000, alpha: 1 }, x: 0, y: 0 }).setVisible(false) : null;
        if(graphics) maskTitleRef.setMask(graphics.createGeometryMask());
        this.titleData.push({graphics, c, path, maskTitleRef});
      }

      //create and postition the letters on the mask
      const letterCont = this.add.container(0, 0).setAngle(-2);
      this.maskCont.add(letterCont);

      let maxWidth = 0;
      this.letters = [];
      const padding = ABCyaLib.Environment.instance.gameConfig.intro.padding;
      const letterRefs = ABCyaPhaser.Localization.instance.getLocalizedString('miscInfo.mask').split('');
      for (let i = 0; i < letterRefs.length; i++) {
        const letter = ABCyaPhaser.Images.addImage(0, 0, letterRefs[i], letterCont, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setScale(0).setAlpha(0);
        this.letters.push(letter);
        maxWidth += letter.width + padding;
        letter.x = i === 0 ? 0 : this.letters[i-1].x + this.letters[i-1].width/2 + this.letters[i].width/2 + padding;
      }
      letterCont.x -= letterCont.getBounds().width/2 - 15;
      letterCont.y = ABCyaLib.Environment.instance.gameConfig.intro.letterY;

      //reposition the ropes to layer above/below the mask.
      this.ropes.forEach(rope => { if(rope.z === 1) this.children.moveAbove(rope, this.maskCont); });
    }

    animateRopes()
    {
      if(!ABCyaLib.DEVICE_INFO.iOS){
        ABCyaPhaser.Tweens.addPathTween(this.topRopesData.c, this.topRopesData.path, 1500, {
          onUpdate: (tween) => {
            if(tween.totalProgress < .46){
              this.topRopes[0].graphics.fillCircle(this.topRopesData.c.x, this.topRopesData.c.y, 18);
            }
            if(tween.totalProgress >= .43 && tween.totalProgress < .84){
              this.topRopes[1].graphics.fillCircle(this.topRopesData.c.x, this.topRopesData.c.y, 18);
            }
            if(tween.totalProgress >= .81){
              this.topRopes[2].graphics.fillCircle(this.topRopesData.c.x, this.topRopesData.c.y, 18);
            }
          }
        }, Phaser.Math.Easing.Linear);
  
        //animate the bottom rope mask path tween
        ABCyaPhaser.Tweens.addPathTween(this.botRopesData.c, this.botRopesData.path, 2500, {
          onUpdate: (tween) => {
            if(tween.totalProgress < .2){
              this.botRopes[4].graphics.fillCircle(this.botRopesData.c.x, this.botRopesData.c.y, 22);
            }
            if(tween.totalProgress >= .19 && tween.totalProgress < .48){
              this.botRopes[3].graphics.fillCircle(this.botRopesData.c.x, this.botRopesData.c.y, 22);
            }
            if(tween.totalProgress >= .44 && tween.totalProgress < .65){
              this.botRopes[2].graphics.fillCircle(this.botRopesData.c.x, this.botRopesData.c.y, 22);
            }
            if(tween.totalProgress >= .62 && tween.totalProgress < .98){
              this.botRopes[1].graphics.fillCircle(this.botRopesData.c.x, this.botRopesData.c.y, 22);
            }
            if(tween.totalProgress >= .95){
              this.botRopes[0].graphics.fillCircle(this.botRopesData.c.x, this.botRopesData.c.y, 22);
            }
          }
        }, Phaser.Math.Easing.Linear);
      } else {
        this.topRopes.forEach(rope => { 
          rope.setAlpha(0);
          this.addTween(rope, 1000, { alpha: 1, delay: 1000 }, Phaser.Math.Easing.Linear);
        });
        this.botRopes.forEach(rope => { 
          rope.setAlpha(0);
          this.addTween(rope, 1000, { alpha: 1, delay: 1000 }, Phaser.Math.Easing.Linear);
        });
      }
    }

    animateMask()
    {
      this.maskCont.setScale(1.2);

      //animate the mask
      this.addTween(this.maskCont, 250, { scale: .8, alpha: 1, delay: 1000 }, Phaser.Math.Easing.Linear, () => {
        this.playSound("title_tweens");
        this.addTween(this.maskCont, 250, { scale: 1.2, angle: -5, delay: 50 }, Phaser.Math.Easing.Quadratic.Out, () => { 
          this.addTween(this.maskCont, 250, { scale: 1, angle: 0, delay: 50 }, Phaser.Math.Easing.Quadratic.In, () => {
            //animate the title
            for (let i = 0; i < this.titleData.length; i++) {
              const time = 400;
              ABCyaPhaser.Tweens.addPathTween(this.titleData[i].c, this.titleData[i].path, time, {
                onUpdate: () => { this.titleData[i].graphics?.fillCircle(this.titleData[i].c.x, this.titleData[i].c.y, 12); },
                delay:time * i
              }, Phaser.Math.Easing.Linear);
            }

            //animate the letters
            for (let i = 0; i < this.letters.length; i++) {
              this.addTween(this.letters[i], 1000, { alpha: 1, delay: 500 + (150 * i) }, Phaser.Math.Easing.Quadratic.Out, ()=>{
                //tween in play buttons on last letter tween in
                if(i >= this.letters.length - 1) {
                  this.tweenInIntro();
                }
              });

              this.addTween(this.letters[i], 325, { scale: 1.2, delay: 500 + (150 * i) }, Phaser.Math.Easing.Quadratic.Out, () => { 
                this.addTween(this.letters[i], 300, { scale: .8, delay: 150 }, Phaser.Math.Easing.Quadratic.InOut, () => { 
                  this.addTween(this.letters[i], 150, { scale: 1 }, Phaser.Math.Easing.Quadratic.In);
                }); 
              });
            };
          });
        }); 
      });
    }

    playJingle()
    {
        let counter = 0;
        for (let i = 0; i < this.sound.sounds.length; i++) if (this.sound.sounds[i].currentMarker.name === "jingle_make_a_mask") counter++;
        if (counter === 0) this.playSound("jingle_make_a_mask", .5, true);
    }

    btnHandler(lang)
    {
        this.playSound("click");

        this.toggleBtns(false);

        if(lang === "spanish") {
          gameData.maskLocalization.isDefault = false;
          gameData.defaultSpanish = true;
        }
        if(lang === "english" && !gameData.maskLocalization.isDefault) {
          gameData.maskLocalization.isDefault = true;
          gameData.defaultSpanish = false;
        }

        gameData.language = lang;
        gameData.gameMode = 0;

        this.tweenOutIntro();
    }

    toggleBtns(onOff)
    {
        this.englishBtnBG.setEnabled(onOff);
        this.spanishBtnBG?.setEnabled(onOff);
    }

    tweenInIntro()
    {
      this.playSound("title_tweens");
      this.maskTitleBG.setAlpha(1);

      //graphics and mask cleanup
      this.titleData.forEach(title => { 
        title.graphics?.destroy();
        title.maskTitle?.setMask(null);
        title.maskTitle?.destroy(); 
      });
      this.topRopes.forEach(rope => {
        rope.setMask(null);
        rope.graphics?.destroy();
      });
      this.botRopes.forEach(rope => { 
        rope.setMask(null);
        rope.graphics?.destroy();
      });
      
      this.addTween(this.englishBtn, 500, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out,
        () => { this.toggleBtns(true); });
      if(this.spanishBtn) this.addTween(this.spanishBtn, 500, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out);
    }

    tweenOutIntro()
    {
        this.playSound("title_tweens");

        this.addTween(this.masker, 700, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In);

        this.addTween(this.englishBtn, 700, { scaleX: 0, scaleY: 0, delay: 50 }, Phaser.Math.Easing.Back.In,
          () => { this.cleanUp(); });
        if(this.spanishBtn) this.addTween(this.spanishBtn, 700, { scaleX: 0, scaleY: 0, delay: 150 }, Phaser.Math.Easing.Back.In);

        this.addTween(this.maskCont, 300, { scale: 1.2, angle: 3 }, Phaser.Math.Easing.Quadratic.InOut, () => { 
          this.addTween(this.maskCont, 250, { scale: 1, angle: 0, alpha: 0, delay: 50 }, Phaser.Math.Easing.Quadratic.In);
        }); 

        this.topRopes.forEach(rope => { 
          this.addTween(rope, 600, { y: rope.y - 100, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out); 
        });
        this.botRopes.forEach(rope => { 
          this.addTween(rope, 600, { y: rope.y + 100, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out); 
        });
    }

    cleanUp()
    {
        this.englishBtn.destroy();
        this.spanishBtn?.destroy();

        this.scene.start("Game");
    }
}